// extracted by mini-css-extract-plugin
export default {"container":"CurrentClubCard_container__6xnZS","id":"CurrentClubCard_id__hL1In","title":"CurrentClubCard_title__VClAt","address":"CurrentClubCard_address__JHhDN"};